module.exports = __webpack_public_path__ + "static/media/door04.80fb9db8.png";